import template from './booking-multi.html';
import controller from './booking-multi.controller';
import './booking-multi.styl';

const bookingMultiComponent = {
  template,
  controller,
  controllerAs: 'bookingMulti',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

export default bookingMultiComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-multi/booking-multi.component.js
 **/